import { useContext, useState, useEffect } from "react";
import { ThemeContext } from "./ThemeProvider";
import { deepMerge } from "./tokenEngine";
import { useThemeMode } from "./useThemeMode";
import { loadBrandingTheme } from "./themes";

// Cache for default theme to avoid repeated loading
let defaultThemeCache = null;

export const useAppTheme = () => {
  const themeContext = useContext(ThemeContext);
  const [defaultTheme, setDefaultTheme] = useState(null);
  const mode = useThemeMode(); // Call hook at top level

  useEffect(() => {
    // Load default theme from registry on mount
    if (!defaultThemeCache) {
      loadBrandingTheme("default", mode).then((themeTokens) => {
        const merged = deepMerge(themeTokens.tenantBase, themeTokens.mode);
        defaultThemeCache = merged;
        setDefaultTheme(merged);
      });
    } else {
      setDefaultTheme(defaultThemeCache);
    }
  }, [mode]); // Add mode as dependency

  // Return context theme if available, otherwise use cached default
  return themeContext?.tokens || defaultTheme;
};
